<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createMenu',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="60%" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="() => emit('cancel')">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">

                <!-- ==================== 改动提示条 ==================== -->
                <a-alert v-if="state.changedFields.size > 0" type="warning" show-icon style="margin-bottom: 12px"
                    :message="`本次共修改 ${state.changedFields.size} 个价格字段（红色高亮显示）`">
                    <template #action>
                        <a-button size="small" type="link" @click="clearChanged">清除高亮</a-button>
                    </template>
                </a-alert>

                <!-- ==================== 1. 基础信息 ==================== -->
                <a-card size="small" class="section-card" title="① 基础信息">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="用户名">
                                {{ props.detailData.nickname }}
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="平台" name="platform_id">
                                <a-select allow-clear @change="selectPlatformChange" style="width: 100%"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    v-model:value="formState.platform_id" placeholder="请选择平台简称">
                                    <a-select-option v-for="(item, index) in state.platformServicesList" :key="index"
                                        :value="item.id" :title="item.platform_name">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-card>

                <template v-if="formState.platform_id">

                    <!-- ==================== 2. 状态与时间 ==================== -->
                    <a-card size="small" class="section-card" title="② 状态与时间">
                        <a-row :gutter="16">
                            <a-col :span="12">
                                <a-form-item label="状态">
                                    <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.status"
                                        checked-children="启用" un-checked-children="禁用" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="时间范围" name="between_time">
                                    <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                        @change="rangTimeChange" :format="format" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-card>

                    <!-- ==================== 3. 前缀配置 ==================== -->
                    <a-card size="small" class="section-card" title="③ 前缀配置">
                        <a-form-item label="公司前缀" name="company_prefix">
                            <a-select allow-clear :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                style="width: 100%" placeholder="请选择（可多选）" v-model:value="formState.company_prefix"
                                mode="multiple">
                                <a-select-option v-for="(item, index) in state.options.company_address_number_prefix"
                                    :key="index" :value="item">
                                    {{ item }}
                                </a-select-option>
                            </a-select>
                            <div class="tip-text">置空则按平台规则</div>
                        </a-form-item>
                        <a-form-item label="个体前缀" name="individual_prefix">
                            <a-select allow-clear :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                style="width: 100%" placeholder="请选择（可多选）" v-model:value="formState.individual_prefix"
                                mode="multiple">
                                <a-select-option v-for="(item, index) in state.options.individual_address_number_prefix"
                                    :key="index" :value="item">
                                    {{ item }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-card>

                    <!-- ==================== 4. 公司价格 ==================== -->
                    <a-card size="small" class="section-card">
                        <template #title>
                            <span>④ 公司价格</span>
                            <a-button type="link" size="small" style="margin-left: 12px" @click="openBatch('company')">
                                <template #icon>
                                    <SettingOutlined />
                                </template>
                                批量设置
                            </a-button>
                        </template>
                        <div class="price-mode">
                            <span class="price-mode-label">价格模式：</span>
                            <a-radio-group button-style="solid" v-model:value="formState.company_postfix_type">
                                <a-radio-button :value="1">自定义</a-radio-button>
                                <a-radio-button :value="2">跟随平台（跟随代理商价格）</a-radio-button>
                            </a-radio-group>
                        </div>

                        <a-empty v-if="formState.company_postfix_type == 2" description="跟随平台价格，无需设置" />

                        <a-collapse v-else v-model:activeKey="state.companyActiveKeys" :bordered="false" ghost>
                            <a-collapse-panel v-for="(item, index) in formState.company_postfix_zdy" :key="item.name">
                                <template #header>
                                    <span class="collapse-title">{{ item.name }}</span>
                                </template>

                                <!-- 设立 / 迁入 两栏并排 -->
                                <a-row :gutter="16">
                                    <!-- 设立 -->
                                    <a-col :span="12">
                                        <table class="price-table">
                                            <thead>
                                                <tr class="group-row">
                                                    <td colspan="5">【设立】公司小规模价格</td>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <th class="col-label"></th>
                                                <th>包注册</th>
                                                <th>裸地址</th>
                                                <th>一次性</th>
                                                <th>续费</th>
                                            </tr>
                                            <tbody>
                                                <tr>
                                                    <td class="col-label">出厂价</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price1 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price2 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price3 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price4 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">零售价</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend1 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend2 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend3 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend4 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">设置</td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price1"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price1') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price2"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price2') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price3"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price3') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price4"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price4') }" />
                                                    </td>
                                                </tr>
                                                <template v-if="item.xukeddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">许可价格</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price1 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price2 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price3 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price4 }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price1"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price1') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price2"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price2') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price3"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price3') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price4"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price4') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-if="item.ybrddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">【设立】公司一般人价格</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="col-label"></th>
                                                        <th>包注册</th>
                                                        <th>裸地址</th>
                                                        <th>一次性</th>
                                                        <th>续费</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price1 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price2 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price3 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price4 }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">零售价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend1 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend2 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend3 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend4 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price1"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price1') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price2"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price2') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price3"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price3') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price4"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price4') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </a-col>

                                    <!-- 迁入 -->
                                    <a-col :span="12">
                                        <table class="price-table">
                                            <thead>
                                                <tr class="group-row">
                                                    <td colspan="5">【迁入】公司小规模价格</td>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <th class="col-label"></th>
                                                <th>包注册</th>
                                                <th>裸地址</th>
                                                <th>一次性</th>
                                                <th>续费</th>
                                            </tr>
                                            <tbody>
                                                <tr>
                                                    <td class="col-label">出厂价</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price11 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price12 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price13 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.price14 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">零售价</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend11 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend12 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend13 }}</td>
                                                    <td>{{ state.options.company_ccj[item.name]?.recommend14 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">设置</td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price11"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price11') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price12"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price12') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price13"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price13') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price14"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('company', item.name, 'price14') }" />
                                                    </td>
                                                </tr>
                                                <template v-if="item.xukeddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">许可价格</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price11 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price12 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price13 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.xk_price14 }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price11"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price11') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price12"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price12') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price13"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price13') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price14"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'xk_price14') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-if="item.ybrddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">【迁入】公司一般人价格</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="col-label"></th>
                                                        <th>包注册</th>
                                                        <th>裸地址</th>
                                                        <th>一次性</th>
                                                        <th>续费</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price11 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price12 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price13 }}</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_price14 }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">零售价</td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend11 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend12 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend13 }}
                                                        </td>
                                                        <td>{{ state.options.company_ccj[item.name]?.ybr_recommend14 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price11"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price11') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price12"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price12') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price13"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price13') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price14"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('company', item.name, 'ybr_price14') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </a-col>
                                </a-row>
                            </a-collapse-panel>
                        </a-collapse>
                    </a-card>

                    <!-- ==================== 5. 个体价格 ==================== -->
                    <a-card size="small" class="section-card">
                        <template #title>
                            <span>⑤ 个体价格</span>
                            <a-button type="link" size="small" style="margin-left: 12px"
                                @click="openBatch('individual')">
                                <template #icon>
                                    <SettingOutlined />
                                </template>
                                批量设置
                            </a-button>
                        </template>
                        <div class="price-mode">
                            <span class="price-mode-label">价格模式：</span>
                            <a-radio-group button-style="solid" v-model:value="formState.individual_postfix_type">
                                <a-radio-button :value="1">自定义</a-radio-button>
                                <a-radio-button :value="2">跟随平台（跟随代理商价格）</a-radio-button>
                            </a-radio-group>
                        </div>

                        <a-empty v-if="formState.individual_postfix_type == 2" description="跟随平台价格，无需设置" />

                        <a-collapse v-else v-model:activeKey="state.individualActiveKeys" :bordered="false" ghost>
                            <a-collapse-panel v-for="(item, index) in formState.individual_postfix_zdy"
                                :key="item.name">
                                <template #header>
                                    <span class="collapse-title">{{ item.name }}</span>
                                </template>

                                <!-- 设立 / 迁入 两栏并排 -->
                                <a-row :gutter="16">
                                    <!-- 设立 -->
                                    <a-col :span="12">
                                        <table class="price-table">
                                            <thead>
                                                <tr class="group-row">
                                                    <td colspan="5">【设立】个体小规模价格</td>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <th class="col-label"></th>
                                                <th>包注册</th>
                                                <th>裸地址</th>
                                                <th>一次性</th>
                                                <th>续费</th>
                                            </tr>
                                            <tbody>
                                                <tr>
                                                    <td class="col-label">出厂价</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price1 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price2 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price3 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price4 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">零售价</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend1 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend2 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend3 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend4 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">设置</td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price1"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price1') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price2"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price2') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price3"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price3') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price4"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price4') }" />
                                                    </td>
                                                </tr>
                                                <template v-if="item.xukeddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">许可价格</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price1 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price2 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price3 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price4 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price1"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price1') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price2"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price2') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price3"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price3') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price4"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price4') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-if="item.ybrddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">【设立】个体一般人价格</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="col-label"></th>
                                                        <th>包注册</th>
                                                        <th>裸地址</th>
                                                        <th>一次性</th>
                                                        <th>续费</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price1 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price2 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price3 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price4 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">零售价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend1
                                                            }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend2
                                                            }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend3
                                                            }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend4
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price1"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price1') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price2"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price2') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price3"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price3') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price4"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price4') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </a-col>

                                    <!-- 迁入 -->
                                    <a-col :span="12">
                                        <table class="price-table">
                                            <thead>
                                                <tr class="group-row">
                                                    <td colspan="5">【迁入】个体小规模价格</td>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <th class="col-label"></th>
                                                <th>包注册</th>
                                                <th>裸地址</th>
                                                <th>一次性</th>
                                                <th>续费</th>
                                            </tr>
                                            <tbody>
                                                <tr>
                                                    <td class="col-label">出厂价</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price11 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price12 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price13 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.price14 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">零售价</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend11 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend12 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend13 }}</td>
                                                    <td>{{ state.options.individual_ccj[item.name]?.recommend14 }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="col-label">设置</td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price11"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price11') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price12"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price12') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price13"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price13') }" />
                                                    </td>
                                                    <td>
                                                        <a-input size="small" v-model:value="item.price14"
                                                            placeholder="价格"
                                                            :class="{ 'input-changed': isChanged('individual', item.name, 'price14') }" />
                                                    </td>
                                                </tr>
                                                <template v-if="item.xukeddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">许可价格</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price11 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price12 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price13 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.xk_price14 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price11"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price11') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price12"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price12') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price13"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price13') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.xk_price14"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'xk_price14') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-if="item.ybrddprice">
                                                    <tr class="group-row">
                                                        <td colspan="5">【迁入】个体一般人价格</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="col-label"></th>
                                                        <th>包注册</th>
                                                        <th>裸地址</th>
                                                        <th>一次性</th>
                                                        <th>续费</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">出厂价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price11 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price12 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price13 }}
                                                        </td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_price14 }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">零售价</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend11
                                                        }}</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend12
                                                        }}</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend13
                                                        }}</td>
                                                        <td>{{ state.options.individual_ccj[item.name]?.ybr_recommend14
                                                        }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-label">设置</td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price11"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price11') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price12"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price12') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price13"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price13') }" />
                                                        </td>
                                                        <td>
                                                            <a-input size="small" v-model:value="item.ybr_price14"
                                                                placeholder="价格"
                                                                :class="{ 'input-changed': isChanged('individual', item.name, 'ybr_price14') }" />
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </a-col>
                                </a-row>
                            </a-collapse-panel>
                        </a-collapse>
                    </a-card>

                    <!-- ==================== 6. 数量与期限限制 ==================== -->
                    <a-card size="small" class="section-card" title="⑥ 数量与期限限制">
                        <a-row :gutter="16">
                            <a-col :span="12">
                                <a-form-item label="未付款数量最多">
                                    <a-input style="width: 100%" addonAfter="家" v-model:value="formState.unpaid_num" />
                                    <div class="tip-text">0 为按平台规则</div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="未办结数量最多">
                                    <a-input style="width: 100%" addonAfter="家"
                                        v-model:value="formState.unfinished_num" />
                                    <div class="tip-text">0 为按平台规则</div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="账期天数">
                                    <a-input style="width: 100%" addonAfter="天" v-model:value="formState.period_days" />
                                    <div class="tip-text">0 为按平台规则</div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="续费保护期天数">
                                    <a-input style="width: 100%" addonAfter="天"
                                        v-model:value="formState.renew_protect_day" />
                                    <div class="tip-text">0 为按平台规则</div>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-card>

                    <!-- ==================== 7. 短信与实名 ==================== -->
                    <a-card size="small" class="section-card" title="⑦ 短信与实名">
                        <a-form-item label="是否开启短信通知" name="smsflag">
                            <a-radio-group button-style="solid" v-model:value="formState.smsflag">
                                <a-radio-button :value="0">跟随平台</a-radio-button>
                                <a-radio-button :value="1">开启</a-radio-button>
                                <a-radio-button :value="2">关闭</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="手机号码实名认证" name="shiming_flag">
                            <a-radio-group button-style="solid" v-model:value="formState.shiming_flag">
                                <a-radio-button :value="0">跟随平台</a-radio-button>
                                <a-radio-button :value="1">开启</a-radio-button>
                                <a-radio-button :value="2">关闭</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item v-if="formState.shiming_flag == 1" label="核验手机号码时间">
                            <a-input style="width: 200px" addonAfter="月" v-model:value="formState.shiming_telusetime" />
                        </a-form-item>
                    </a-card>

                    <!-- ==================== 8. 权限开关 ==================== -->
                    <a-card size="small" class="section-card" title="⑧ 权限开关">
                        <a-row :gutter="16">
                            <a-col :span="12">
                                <a-form-item label="万能支付权限">
                                    <a-switch :checkedValue="1" :unCheckedValue="2"
                                        v-model:checked="formState.universal_payment" checked-children="授权"
                                        un-checked-children="未授权" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="列表页查看股东手机号">
                                    <a-switch :checkedValue="1" :unCheckedValue="2"
                                        v-model:checked="formState.look_gd_tel" checked-children="可以看"
                                        un-checked-children="不可以看" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="通讯录验证码含企查查/天眼查">
                                    <a-switch :checkedValue="1" :unCheckedValue="2"
                                        v-model:checked="formState.include_qcctyc_sms" checked-children="包含"
                                        un-checked-children="不包含" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="允许突破限制使用余额支付">
                                    <a-switch :checkedValue="1" :unCheckedValue="2"
                                        v-model:checked="formState.can_use_yue" checked-children="突破限制"
                                        un-checked-children="随系统设置" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-card>

                    <!-- ==================== 9. 其他规则 ==================== -->
                    <a-card size="small" class="section-card" title="⑨ 其他规则">
                        <a-form-item label="推送做单-须先付款" name="push_need_pay">
                            <a-radio-group button-style="solid" v-model:value="formState.push_need_pay">
                                <a-radio-button :value="0">跟随平台</a-radio-button>
                                <a-radio-button :value="1">需要</a-radio-button>
                                <a-radio-button :value="2">不需要</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="下载电子化资料-须先付款" name="downloaddzhfile_ispay">
                            <a-radio-group button-style="solid" v-model:value="formState.downloaddzhfile_ispay">
                                <a-radio-button :value="0">跟随平台</a-radio-button>
                                <a-radio-button :value="1">需要</a-radio-button>
                                <a-radio-button :value="2">不需要</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="超期未传资料-限制录单" name="overdue_ludan">
                            <a-radio-group button-style="solid" v-model:value="formState.overdue_ludan">
                                <a-radio-button :value="0">跟随平台</a-radio-button>
                                <a-radio-button :value="1">限制</a-radio-button>
                                <a-radio-button :value="2">不限制</a-radio-button>
                            </a-radio-group>
                            <div class="tip-text">营业执照或租赁合同，需平台开启超期考核</div>
                        </a-form-item>
                        <a-form-item label="改价格备注">
                            <a-input placeholder="当价格修改时请备注" v-model:value="formState.price_reason" />
                        </a-form-item>
                    </a-card>
                </template>

                <!-- ==================== 批量设置价格弹窗 ==================== -->
                <a-modal v-model:open="batchState.visible" title="批量设置价格" width="560px"
                    :confirmLoading="batchState.loading" @ok="applyBatch">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                        <a-form-item label="基准价格">
                            <a-radio-group button-style="solid" v-model:value="batchState.baseType">
                                <a-radio-button value="factory">按出厂价</a-radio-button>
                                <a-radio-button value="recommend">按零售价</a-radio-button>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item label="计算方式">
                            <a-radio-group button-style="solid" v-model:value="batchState.calcType">
                                <a-radio-button value="add">加固定金额</a-radio-button>
                                <a-radio-button value="percent">加百分比(%)</a-radio-button>
                                <a-radio-button value="fixed">设为固定值</a-radio-button>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item :label="batchState.calcType === 'percent' ? '百分比' : '数值'">
                            <a-input-number v-model:value="batchState.value" style="width: 180px"
                                :min="batchState.calcType === 'percent' ? -100 : undefined" :precision="2"
                                :placeholder="batchState.calcType === 'percent' ? '如 10 表示加 10%' : '请输入数值'" />
                            <div class="tip-text" style="margin-top: 4px">
                                <span v-if="batchState.calcType === 'add'">最终 = 基准价格 + 数值</span>
                                <span v-else-if="batchState.calcType === 'percent'">最终 = 基准价格 × (1 + 数值/100)</span>
                                <span v-else-if="batchState.calcType === 'fixed'">最终 = 数值（全部设为该值）</span>
                            </div>
                        </a-form-item>

                        <a-form-item label="应用范围">
                            <a-checkbox-group v-model:value="batchState.scope">
                                <a-checkbox value="base">基础价格</a-checkbox>
                                <a-checkbox value="xk">许可价格</a-checkbox>
                                <a-checkbox value="ybr">一般人价格</a-checkbox>
                            </a-checkbox-group>
                        </a-form-item>

                        <a-form-item label="设立/迁入">
                            <a-checkbox-group v-model:value="batchState.direction">
                                <a-checkbox value="sheli">设立</a-checkbox>
                                <a-checkbox value="qianru">迁入</a-checkbox>
                            </a-checkbox-group>
                        </a-form-item>

                        <a-form-item label=" ">
                            <div class="tip-text">
                                提示：只对当前价格模式下"自定义"的项目生效；跟随平台的不受影响。
                            </div>
                        </a-form-item>
                    </a-form>
                </a-modal>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createMenu">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import { SettingOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'

const format = 'YYYY-MM-DD HH:mm:ss'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {
    permissions: [{ required: true, message: '请选择菜单权限', trigger: 'change' }]
}
const formLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 15 },
        sm: { span: 15 }
    }
}
interface platformServicesList {
    id: number
    name: string
    company_area_name: string
    company_city_name: string
    platform_name: string
    company_province_name: string
}
interface state {
    modalTitle: string
    loading: boolean
    platformServicesList: platformServicesList[]
    options: any
    companyActiveKeys: string[]
    individualActiveKeys: string[]
    changedFields: Set<string>
}
const state = reactive<state>({
    modalTitle: '编辑用户平台权限',
    loading: false,
    platformServicesList: [],
    options: {},
    companyActiveKeys: [],
    individualActiveKeys: [],
    changedFields: new Set<string>()
})

// ============ 批量设置状态 ============
const batchState = reactive({
    visible: false,
    loading: false,
    target: '' as 'company' | 'individual' | '',
    baseType: 'factory' as 'factory' | 'recommend',
    calcType: 'add' as 'add' | 'percent' | 'fixed',
    value: 50 as number,
    scope: ['base', 'ybr'] as string[],       // 默认勾选：基础 + 许可 + 一般人
    direction: ['sheli', 'qianru'] as string[]
})

interface formState {
    platform_id: number | null
    status: number
    between_time: string | null
    company_prefix: string[]
    individual_prefix: string[]
    company_postfix_type: number
    company_postfix_zdy: any
    individual_postfix_type: number
    individual_postfix_zdy: any
    smsflag: number
    shiming_flag: number
    shiming_telusetime: number
    unpaid_num: number
    unfinished_num: number
    period_days: number
    renew_protect_day: number
    universal_payment: number
    look_gd_tel: number
    include_qcctyc_sms: number
    can_use_yue: number
    push_need_pay: number
    downloaddzhfile_ispay: number
    overdue_ludan: number
    price_reason: string
}
let formState = reactive<formState>({
    platform_id: null,
    status: 1,
    between_time: '',
    company_prefix: [],
    individual_prefix: [],
    company_postfix_type: 2,
    company_postfix_zdy: [],
    individual_postfix_type: 2,
    individual_postfix_zdy: [],
    smsflag: 0,
    shiming_flag: 0,
    shiming_telusetime: 0,
    unpaid_num: 0,
    unfinished_num: 0,
    period_days: 0,
    renew_protect_day: 0,
    universal_payment: 2,
    look_gd_tel: 2,
    include_qcctyc_sms: 2,
    can_use_yue: 2,
    push_need_pay: 0,
    downloaddzhfile_ispay: 0,
    overdue_ludan: 0,
    price_reason: ''
})
onMounted(() => {
    queryCompanyTypeList()
})
// 获取平台信息
const queryCompanyTypeList = () => {
    let requestParam = {
        url: '/admin/user/platform',
        method: 'post',
        data: { type: 2 }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformServicesList = res.data
            if (props.detailData.platform_id) {
                selectPlatformChange(null, { value: props.detailData.platform_id })
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        })
}
// 选择平台之后
const selectPlatformChange = (res, e) => {
    formState.platform_id = e.value
    state.loading = true
    let requeryParam = {
        url: `/admin/user/platformSet`,
        method: 'post',
        data: { userId: props.detailData.id, platformId: e.value }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.loading = false
            state.options = res.data.options
            Object.assign(formState, res.data.form)

            // 切换平台时清空高亮
            state.changedFields = new Set<string>()

            // 默认展开第一个价格项
            const companyList = formState.company_postfix_zdy || []
            if (companyList.length > 0) {
                state.companyActiveKeys = [companyList[0].name]
            }
            const individualList = formState.individual_postfix_zdy || []
            if (individualList.length > 0) {
                state.individualActiveKeys = [individualList[0].name]
            }
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (formState.between_time) {
        array = formState.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        formState.between_time = str.join(',')
    } else {
        formState.between_time = null
    }
}

// ============ 判断输入框是否被批量改过 ============
const isChanged = (target: 'company' | 'individual', name: string, key: string) => {
    return state.changedFields.has(`${target}|${name}|${key}`)
}

// ============ 清除高亮 ============
const clearChanged = () => {
    state.changedFields = new Set<string>()
}

// ============ 打开批量设置弹窗 ============
const openBatch = (target: 'company' | 'individual') => {
    batchState.target = target
    batchState.baseType = 'factory'
    batchState.calcType = 'add'
    batchState.value = 50
    batchState.scope = ['base', 'ybr']        // 默认勾选：基础 + 许可 + 一般人
    batchState.direction = ['sheli', 'qianru']
    batchState.visible = true
}

// ============ 应用批量设置 ============
const applyBatch = () => {
    if (batchState.scope.length === 0) {
        message.warning('请至少勾选一个应用范围')
        return
    }
    if (batchState.direction.length === 0) {
        message.warning('请至少勾选设立或迁入')
        return
    }
    if (batchState.calcType !== 'fixed' && (!batchState.value || batchState.value === 0)) {
        message.warning('数值不能为 0')
        return
    }

    const isCompany = batchState.target === 'company'
    const list = isCompany
        ? formState.company_postfix_zdy
        : formState.individual_postfix_zdy
    const ccjSource = isCompany
        ? state.options.company_ccj
        : state.options.individual_ccj

    if (!list || list.length === 0) {
        message.warning('没有可设置的价格项')
        return
    }

    const getBaseKey = (scope: string, dir: 'sheli' | 'qianru', idx: number) => {
        const isSheli = dir === 'sheli'
        const suffix = isSheli ? `${idx}` : `1${idx}`
        if (batchState.baseType === 'factory') {
            if (scope === 'base') return `price${suffix}`
            if (scope === 'xk') return `xk_price${suffix}`
            if (scope === 'ybr') return `ybr_price${suffix}`
        } else {
            if (scope === 'base') return `recommend${suffix}`
            if (scope === 'xk') return `xk_recommend${suffix}`
            if (scope === 'ybr') return `ybr_recommend${suffix}`
        }
        return ''
    }

    const getTargetKey = (scope: string, dir: 'sheli' | 'qianru', idx: number) => {
        const isSheli = dir === 'sheli'
        const suffix = isSheli ? `${idx}` : `1${idx}`
        if (scope === 'base') return `price${suffix}`
        if (scope === 'xk') return `xk_price${suffix}`
        if (scope === 'ybr') return `ybr_price${suffix}`
        return ''
    }

    const calcFinal = (baseVal: any) => {
        const b = Number(baseVal)
        const v = Number(batchState.value)
        if (isNaN(b)) {
            return batchState.calcType === 'fixed' ? v : null
        }
        if (batchState.calcType === 'add') return +(b + v).toFixed(2)
        if (batchState.calcType === 'percent') return +(b * (1 + v / 100)).toFixed(2)
        if (batchState.calcType === 'fixed') return v
        return null
    }

    let count = 0
    list.forEach((item: any) => {
        batchState.direction.forEach((dir) => {
            for (let i = 1; i <= 4; i++) {
                batchState.scope.forEach((scope) => {
                    if (scope === 'xk' && !item.xukeddprice) return
                    if (scope === 'ybr' && !item.ybrddprice) return

                    const baseKey = getBaseKey(scope, dir as 'sheli' | 'qianru', i)
                    const targetKey = getTargetKey(scope, dir as 'sheli' | 'qianru', i)
                    const baseVal = ccjSource?.[item.name]?.[baseKey]
                    const finalVal = calcFinal(baseVal)
                    if (finalVal !== null) {
                        item[targetKey] = finalVal
                        // 记录改动，触发高亮
                        state.changedFields.add(`${batchState.target}|${item.name}|${targetKey}`)
                        count++
                    }
                })
            }
        })
    })

    if (count === 0) {
        message.warning('没有可设置的价格项，请检查勾选范围或基准价格是否存在')
        return
    }

    message.success(`已批量设置 ${count} 个价格，红色高亮显示改动的项`)
    batchState.visible = false
}

const onFormSubmit = () => {
    if (!formState.platform_id) {
        message.error('请选择平台')
        return
    }
    ruleForm.value.validate().then(() => {
        state.loading = true
        let requeryParam = {
            url: `/admin/user/platformSetSave`,
            method: 'post',
            data: Object.assign(formState, { userId: props.detailData.id, userIds: props.detailData.ids })
        }
        baseService(requeryParam)
            .then((res: any) => {
                state.loading = false
                formState.price_reason = ''
                message.success(res.msg)
                emit('ok')
            })
            .catch((res) => {
                state.loading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    })
}
</script>

<style lang="less" scoped>
/* ============ 通用提示 ============ */
.tip-text {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.4;
}

/* ============ 卡片 ============ */
.section-card {
    margin-bottom: 12px;
    border-radius: 6px;
}

.section-card :deep(.ant-card-head) {
    min-height: 40px;
    padding: 0 16px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
}

.section-card :deep(.ant-card-head-title) {
    padding: 10px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.section-card :deep(.ant-card-body) {
    padding: 16px;
}

/* ============ 表单项 ============ */
:deep(.ant-form-item) {
    margin-bottom: 16px;
}

:deep(.ant-form-item-label > label) {
    font-size: 13px;
    color: #555;
}

/* ============ 价格模式条 ============ */
.price-mode {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    margin-bottom: 16px;
    background: #f0f7ff;
    border-radius: 6px;
    border-left: 3px solid #1890ff;
}

.price-mode-label {
    font-weight: 600;
    margin-right: 12px;
    color: #333;
}

/* ============ 折叠面板 ============ */
:deep(.ant-collapse) {
    background: transparent;
}

:deep(.ant-collapse-item) {
    border-bottom: 1px solid #f0f0f0 !important;
}

:deep(.ant-collapse-header) {
    padding: 10px 12px !important;
    background: #fafafa;
    border-radius: 4px !important;
}

:deep(.ant-collapse-content-box) {
    padding: 16px 8px !important;
}

.collapse-title {
    font-weight: 600;
    color: #333;
    font-size: 13px;
}

/* ============ 价格表格 ============ */
.price-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    table-layout: fixed;
    background: #fff;
    margin-bottom: 12px;
}

.price-table th,
.price-table td {
    border: 1px solid #e8e8e8;
    padding: 6px 4px;
    text-align: center;
    word-break: break-all;
}

.price-table th {
    background: #f5f5f5;
    font-weight: 500;
    color: #666;
    font-size: 12px;
}

.price-table .col-label {
    width: 70px;
    background: #fafafa;
    font-weight: 500;
    color: #666;
    font-size: 12px;
}

.price-table .group-row td {
    background: #e6f7ff;
    color: #1890ff;
    font-weight: 600;
    font-size: 12px;
    text-align: left;
    padding-left: 12px;
}

.price-table :deep(.ant-input) {
    padding: 3px 4px;
    font-size: 13px;
    text-align: center;
}

/* ============ 改动高亮 ============ */
.price-table :deep(.ant-input.input-changed) {
    border-color: #ff4d4f !important;
    background: #fff1f0 !important;
    color: #cf1322 !important;
    font-weight: 600;
}

.price-table :deep(.ant-input.input-changed:focus) {
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}
</style>
